import React, { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { UrlContext } from "../../../contexts/UrlContext";

export default function SelectProfile({
  projectID,
  profiles,
  projectType,
  setShowSelectProfile,
  setIsCalendarOpen,
  refreshEvent,
  setRefreshEvent,
}) {
  const isDownloaded = "/pictures/";
  const { API_URL } = useContext(UrlContext);
  const [selectedProfiles, setSelectedProfiles] = useState([]);
  const [requestLoading, setRequestLoading] = useState(false);
  const [shortLoading, setShortLoading] = useState(false);

  const toggleProfileSelection = (profile) => {
    if (selectedProfiles.includes(profile.expertID)) {
      setSelectedProfiles(
        selectedProfiles.filter((id) => id !== profile.expertID)
      );
    } else {
      setSelectedProfiles([...selectedProfiles, profile.expertID]);
    }
  };

  // API for posting request for call
  const requestForCallinGroup = async () => {
    setRequestLoading(true);
    const requestBody = {
      projectID: projectID,
      expertIDs: selectedProfiles,
      client: true,
    };
    try {
      let modifiedUrl = "request-for-call-in-group";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setRefreshEvent(!refreshEvent);
        setShowSelectProfile(false);
        setIsCalendarOpen(false);
        Swal.fire({
          title: "Thank you!",
          text: "We will schedule a call as soon as posible.",
          icon: "success",
          confirmButtonText: "OK",
          timer: 5000,
          timerProgressBar: true,
        });
      } else {
        Swal.fire({
          text: responseData.text,
          icon: "warning",
          confirmButtonText: "OK",
          timer: 5000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
    setRequestLoading(false);
  };

  // API for shortlisting consultants
  const shortListProfiles = async () => {
    setShortLoading(true);
    const requestBody = {
      projectID: projectID,
      expertIDs: selectedProfiles,
      client: true,
    };
    try {
      let modifiedUrl = "select-consultant-for-call-in-group";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setRefreshEvent(!refreshEvent);
        setShowSelectProfile(false);
        setIsCalendarOpen(false);
        Swal.fire({
          title: "Shortlisted!",
          text: "Profile has been added to short-list!",
          icon: "success",
          // confirmButtonText: "OK",
        });
      } else {
        console.error("Failed to add selected consultant");
        Swal.fire({
          text: responseData.text,
          icon: "warning",
          confirmButtonText: "OK",
          timer: 5000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
      Swal.fire({
        title: "Error!",
        text: "Unexpected error!",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
    setShortLoading(false);
  };

  return (
    <>
      <div className="decline-wrapper">
        <div
          className="flex-container-decline-profile"
          style={{
            width: "60%",
            height: "50%",
            padding: "0px",
            border: "none",
            overflowY: "hidden",
          }}
        >
          {/* Header div */}
          <div
            className="flex-item-decline-profile-header"
            style={{ flex: "2%", backgroundColor: "#365561" }}
          >
            <p
              style={{
                fontSize: "16px",
                fontWeight: "500",
                marginLeft: "5px",
                color: "white",
              }}
            >
              Select Profile
            </p>
            <i
              class="fa-solid fa-xmark"
              onClick={() => {
                setShowSelectProfile(false);
                setIsCalendarOpen(false);
              }}
              style={{
                marginRight: "5px",
                marginTop: "3px",
                color: "gray",
                cursor: "pointer",
              }}
            />
          </div>

          {/* Content div */}
          <div
            className="flex-item-sugest-time-slot-calendar"
            style={{
              flex: "98%",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                fontWeight: "500",
                textAlign: "center",
              }}
            >
              Do you want to specify any profile to arrange a call for your
              given availability?
            </div>
            <div
              style={{
                padding: "10px",
                gap: "20px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              {profiles.map((profile, index) => (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    border: selectedProfiles.includes(profile.expertID)
                      ? "1px solid #365561"
                      : "1px solid lightgrey",
                    borderRadius: "5px",
                    boxShadow: selectedProfiles.includes(profile.expertID)
                      ? "0px 0px 8px #365561"
                      : "none",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "20px",
                    }}
                  >
                    {profile.expertProfilePicture ? (
                      <>
                        <div style={{ textAlign: "center", padding: "5px" }}>
                          {profile.expertProfilePicture.includes(
                            isDownloaded
                          ) ? (
                            <img
                              src={`https://images.expertpowerhouse.com${profile.expertProfilePicture}`}
                              style={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "50%",
                              }}
                            />
                          ) : (
                            <img
                              src={profile.expertProfilePicture}
                              width={"50px"}
                              alt=""
                            />
                          )}
                        </div>
                      </>
                    ) : (
                      <>
                        <div style={{ textAlign: "center", padding: "5px" }}>
                          <img
                            src={`https://images.expertpowerhouse.com${"/pictures/dummy.png"}`}
                            style={{
                              width: "50px",
                              height: "50px",
                              borderRadius: "50%",
                            }}
                          />
                        </div>
                      </>
                    )}
                    <div>
                      {profile.hasName ? (
                        <p style={{ fontSize: "14px", fontWeight: "500" }}>
                          {projectType === "exp" ? "EPH_EXP_" : "EPH_CON_"}
                          {profile.expertDigitalID} ({profile.expertName})
                        </p>
                      ) : (
                        <p style={{ fontSize: "14px", fontWeight: "500" }}>
                          {projectType === "exp" ? "EPH_EXP_" : "EPH_CON_"}
                          {profile.expertDigitalID}
                        </p>
                      )}
                      <div
                        className="flex-item-shere-profile-item-profile-info-containter-item-location"
                        style={{ fontSize: "12px", color: "gray" }}
                      >
                        <p>
                          <i class="fa-solid fa-map-location-dot"></i>{" "}
                          {profile.expertLocation}
                        </p>
                        <p style={{ marginTop: "-4px" }}>
                          <i class="fa-solid fa-money-bill-1-wave"></i>{" "}
                          {profile.projectCurrency} {profile.expertDailyRate}{" "}
                          {profile.expertBillingFrequency}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      background: selectedProfiles.includes(profile.expertID)
                        ? "#365561"
                        : "lightgrey",
                      width: "150px",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => toggleProfileSelection(profile)}
                  >
                    <p style={{ color: "white", fontWeight: "500" }}>
                      {selectedProfiles.includes(profile.expertID)
                        ? "Unselect"
                        : "Select"}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              gap: "20px",
            }}
          >
            <button
              className="btn base-btn"
              style={{ width: "120px" }}
              onClick={() => requestForCallinGroup()}
            >
              {requestLoading ? (
                <i class="fa-solid fa-spinner fa-spin"></i>
              ) : (
                "Request Call"
              )}
            </button>
            <button
              className="btn base-btn"
              style={{ width: "120px" }}
              onClick={() => shortListProfiles()}
            >
              {shortLoading ? (
                <i class="fa-solid fa-spinner fa-spin"></i>
              ) : (
                "Shortlist"
              )}
            </button>
            <button
              className="btn-light btn"
              style={{ background: "lightgrey", width: "120px" }}
              onClick={() => {
                setShowSelectProfile(false);
                setIsCalendarOpen(false);
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
